import { getContainer } from "../../../ioc/IOCSetup";
import type { AppliedChange } from "./types";

/**
 * Arms the audit origin header for the write a submit is about to fire when the submitted form
 * still holds a value the assistant set — `changes` are its live records. Records, not on-page
 * markers, decide: a field that is not rendered carries no marker, yet its AI value is still in
 * the form's model and goes out with the save. The page's own save goes through the application
 * HttpService, not the chat's, so that is the instance to arm. Returns whether it armed.
 */
export function armSaveOriginFor(changes: AppliedChange[]): boolean {
  if (changes.length === 0) {
    return false;
  }
  getContainer().getHttpService().armAiAssistedOrigin();
  return true;
}

/**
 * Takes the arm back once a kit submit has settled: whatever write it fired has been tagged by
 * then, and a submit that fired none (validation failed) must not tag an unrelated write later.
 */
export function disarmSaveOrigin(): void {
  getContainer().getHttpService().disarmAiAssistedOrigin();
}
